import { z } from "zod";
import { supervisorOrgUserRoleSchema } from "../supervisorOrg/models.js";

export default {
  params: z.object({
    email: z.email(),
    supervisorOrgId: z.string(),
    role: supervisorOrgUserRoleSchema,
  }),
  response: z.object({
    uid: z.string(),
  }),
};
